import gql from 'graphql-tag';

export const productGroupFragments = gql`
  fragment productGroupFragments on ProductGroup {
    id
    name
    description
  }
`;

export const ALL_PRODUCT_GROUPS = gql`
  query currentUnitProductGroups {
    currentUnit {
      id
      productGroups {
        ...productGroupFragments
        fullPathName
        parentGroup { id }
      }
    }
  },
  ${productGroupFragments}
`;
